"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltSecondaryTag = void 0;
var AltSecondaryTag;
(function (AltSecondaryTag) {
    AltSecondaryTag["REQ"] = "req";
    AltSecondaryTag["OXYGEN"] = "oxygen";
    AltSecondaryTag["TURMOIL"] = "turmoil";
    AltSecondaryTag["FLOATER"] = "floater";
    AltSecondaryTag["BLUE"] = "blue";
    AltSecondaryTag["NO_TAGS"] = "no_tags";
    AltSecondaryTag["MOON_MINING_RATE"] = "moon-mine";
    AltSecondaryTag["MOON_HABITAT_RATE"] = "moon-colony";
    AltSecondaryTag["MOON_LOGISTICS_RATE"] = "moon-road";
    AltSecondaryTag["NO_PLANETARY_TAG"] = "no_planetary_tag";
    AltSecondaryTag["WILD_RESOURCE"] = "wild-resource";
    AltSecondaryTag["DIVERSE"] = "diverse";
    AltSecondaryTag["ARES"] = "ares";
})(AltSecondaryTag || (exports.AltSecondaryTag = AltSecondaryTag = {}));
